import React from 'react';

const UniversityEvents = () => {

  return (
    <section id="events" className="events section">
      <div className="container section-title" data-aos="fade-up">
        <p><span>University </span> <span className="description-title">Events</span></p>
      </div>

      <div className="container" data-aos="fade-up">
        <div className="row gy-4">
          <div className="col-lg-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div className="events-img">
              <img src="/assets/img/events/event-1.jpg" className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div className="events-img">
              <img src="/assets/img/events/event-2.jpg" className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div className="events-img">
              <img src="/assets/img/events/event-3.jpg" className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div className="events-img">
              <img src="/assets/img/events/event-4.jpg" className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div className="events-img">
              <img src="/assets/img/events/event-5.jpg" className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div className="events-img">
              <img src="/assets/img/events/event-6.jpg" className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniversityEvents;
